import React from 'react';
import PropTypes from 'prop-types';

import { BRAND_LIBRARY_LIGHT_TEXT_COLOR, BRAND_LIBRARY_HEADLINE_TEXT } from 'common/constants/brandLibrary';
import { useTouchpointData } from 'common/components/TouchpointEditor/contexts/TouchpointDataContext';

import HeadlineStyled from './EventTitleHeadline.styles';

export default function EventTitleHeadline(props) {
    const {
        event: { title },
    } = useTouchpointData();
    const propsWithEventTitleOverride = {
        ...props,
        meta: {
            ...props.meta,
            content: title,
        },
    };
    return <HeadlineStyled {...propsWithEventTitleOverride} contentEditable={false} />;
}

EventTitleHeadline.propTypes = {
    meta: PropTypes.shape({
        content: PropTypes.string,
    }).isRequired,
};

EventTitleHeadline.splash = {
    ...HeadlineStyled.splash,
    defaultProps: {
        ...HeadlineStyled.splash.defaultProps,
        styles: {
            ...HeadlineStyled.splash.defaultProps.styles,
            fontSize: 40,
            fontColor: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
            fontFamily: BRAND_LIBRARY_HEADLINE_TEXT,
        },
    },
};
